import React from 'react';

type DraftProps = {
  width?: number;
  height?: number;
};

const Draft = ({ width = 32, height = 32 }: DraftProps) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='12' cy='12' r='12' fill='#F4821F' />
      <path
        d='M13 11.5H10M11 13.5H10M14 9.5H10M16 12V9.4C16 8.55992 16 8.13988 15.8365 7.81901C15.6927 7.53677 15.4632 7.3073 15.181 7.16349C14.8601 7 14.4401 7 13.6 7H10.4C9.55992 7 9.13988 7 8.81901 7.16349C8.53677 7.3073 8.3073 7.53677 8.16349 7.81901C8 8.13988 8 8.55992 8 9.4V14.6C8 15.4401 8 15.8601 8.16349 16.181C8.3073 16.4632 8.53677 16.6927 8.81901 16.8365C9.13988 17 9.55992 17 10.4 17H12M14 14L16.5 16.5M16.5 14L14 16.5'
        stroke='white'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Draft;
